import apiClient from "./api";

export const categoryService = {
  /**
   * Получить список категорий
   * @param {Object} params - Параметры запроса
   * @returns {Promise} - Промис с данными
   */
  getCategories(params = {}) {
    return apiClient.get("/categories/", { params });
  },

  /**
   * Получить категорию по ID
   * @param {string|number} id - ID категории
   * @returns {Promise} - Промис с данными
   */
  getCategory(id) {
    return apiClient.get(`/categories/${id}/`);
  },

  getCategoryChildren(categorySlug) {
    return apiClient.get(`/categories/`, {
      params: {
        section: categorySlug,
      },
    });
  },
};

export const newsService = {
  /**
   * Получить список новостей
   * @param {Object} params - Параметры запроса
   * @returns {Promise} - Промис с данными
   */
  getNewsList(params = {}) {
    return apiClient.get("/category/news/", { params });
  },
};

export const faqService = {
  /**
   * Получить список вопросов и ответов
   * @param {Object} params - Параметры запроса
   * @returns {Promise} - Промис с данными
   */
  getFaqList(params = {}) {
    return apiClient.get("/category/qa/", { params });
  },

  /**
   * Получить вопрос по ID
   * @param {string|number} id - ID вопроса
   * @returns {Promise} - Промис с данными
   */
  getFaqItem(id) {
    return apiClient.get(`/category/qa/${id}/`);
  },
};

export const articleService = {
  /**
   * Получить статью по ID
   * @param {string|number} id - ID статьи
   * @returns {Promise} - Промис с данными
   */
  getArticle(id) {
    return apiClient.get(`/article/read/${id}/`);
  },

  getArtcileFromCategory(categorySlug, articleId) {
    return apiClient.get(`/category/${categorySlug}/${articleId}/`);
  },

  getRelatedArticles(categorySlug, params = {}) {
    return apiClient.get(`/category/${categorySlug}`, { params });
  },
};

export const tourOperatorService = {
  getTourOperators(params = {}) {
    return apiClient.get("/companies/", { params });
  },

  getTourOperator(id) {
    return apiClient.get(`/companies/${id}/`);
  },
};

export const hajiService = {
  getHajis(params = {}) {
    return apiClient.get("/pilgrims/", { params });
  },

  getHaji(id) {
    return apiClient.get(`/pilgrims/${id}/`);
  },

  likeHaji(id) {
    return apiClient.post(`/pilgrim/${id}/like/`);
  },

  createHaji(data) {
    // formData to json
    const formData = new FormData();
    Object.keys(data).forEach((key) => {
      formData.append(key, data[key]);
    });

    return apiClient.post("/pilgrims/", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  },
};

export const geoService = {
  getPilgrimRegions(params = {}) {
    return apiClient.get("/regions/", { params });
  },

  getRegions(params = {}) {
    return apiClient.get("https://api.muftyat.kz/api/v1/get/regions/", {
      params,
    });
  },

  getCities(regionId, params = {}) {
    return apiClient.get(
      `https://api.muftyat.kz/api/v1/get/region/${regionId}/`,
      {
        params,
      }
    );
  },

  getDistricts(regionId) {
    return apiClient.get(`https://api.muftyat.kz/api/v1/get/cities/`, {
      params: {
        city_type: 2,
        region: regionId,
      },
    });
  },

  searchRegions(query) {
    // `${this.apiHost}/api/v1/get/cities/?ordering=-title_kk&search=${regionName}`
    return apiClient.get(`https://api.muftyat.kz/api/v1/get/cities/`, {
      params: {
        ordering: "-title_kk",
        search: query,
      },
    });
  },

  getDayIndexInYear(date = new Date()) {
    const start = new Date(date.getFullYear(), 0, 1); // Jan 1st of current year
    const diff = date - start;
    return Math.floor(diff / (1000 * 60 * 60 * 24));
  },

  async getPrayerTimes(lat, lng) {
    const year = new Date().getFullYear();
    const dayIndex = this.getDayIndexInYear();
    console.log(dayIndex, year);
    const response = await apiClient.get(
      `https://api.muftyat.kz/prayer-times/${year}/${lat}/${lng}`
    );

    if (response.result.length === 0) {
      return null;
    }

    const prayerTimes = response.result[dayIndex];

    return prayerTimes;
  },

  async getHajjDate() {
    const result = await apiClient.get("/hajj_date/");
    console.log(result);

    return result.results.find((i) => i.is_published);
  },
};

export const mediaService = {
  getMedia(mediaType, params = {}) {
    return apiClient.get(`/media/${mediaType}/`, { params });
  },

  getMediaItem(mediaType, id) {
    console.log(mediaType, id);
    return apiClient.get(`/media/read/${id}/`);
  },
};

export const holyPlacesService = {
  getMeccaHolyPlaces(params = {}) {
    return apiClient.get("/media/photo/?category__slug=mecca", { params });
  },
  getMedinaHolyPlaces(params = {}) {
    return apiClient.get("/media/photo/?category__slug=madinah", { params });
  },
};

export const authService = {
  login(username, password) {
    return apiClient.post("/jwt/token/", { username, password });
  },

  verifyToken(token) {
    return apiClient.post("/jwt/token/verify/", { token });
  },

  getUserProfile() {
    return apiClient.get("/user/");
  },

  register(data) {
    return apiClient.post("/users/", data);
  },

  updateUserProfile(userId, firstName, email) {
    return apiClient.post(`/users/${userId}/`, {
      id: userId,
      first_name: firstName,
      // last_name: lastName,
      email: email,
    });
  },
};

export const duaService = {
  getDuas(params = {}) {
    return apiClient.get("/dua_prayers/", { params });
  },
  getDua(id) {
    return apiClient.get(`/dua_prayers/${id}/`);
  },
  createDua(data) {
    return apiClient.post("/dua_prayers/", data);
  },
  likeDua(id) {
    return apiClient.post(`/dua_prayers/${id}/like/`);
  },
};

export const tourService = {
  createOrder(data) {
    return apiClient.post("/tour/order/", data);
  },
};

export const flatPagesService = {
  getFlatPages() {
    return apiClient.get(`/flatpages/`);
  },
};
